@let styling = status() | statusStyle: styleMap();
<div class="table-cell">
  @if (styling.icon) {
    <gc-icon [iconName]="styling.icon.name" [color]="styling.icon.color" />
  }
  <div class="text-wrapper">
    <gc-text [variant]="'paragraph'" [textColor]="styling.textColor">{{
      firstLine()
    }}</gc-text>
    @if (secondLine()) {
      <gc-text [variant]="'paragraph'" [textColor]="styling.textColor">{{
        secondLine()
      }}</gc-text>
    }
  </div>
</div>
